import { useCurrencyFormat } from '@/hooks/useCurrencyFormat';
import React from 'react';

import { useState } from 'react';
import InputRange from 'react-input-range';

interface Props {
  min: number;
  max: number;
  onChange: (from: number, to: number) => void;
}
const PriceSliderFilter = ({ min, max, onChange }: Props) => {
  const { formatCurrency } = useCurrencyFormat();
  const [price, setPrice] = useState({
    value: { min: min, max: max },
  });
  React.useEffect(() => {
    setPrice({
      value: {
        min: min,
        max: max,
      },
    });
  }, [min, max]);
  const handleOnChange = value => {
    setPrice({ value });
  };

  return (
    <div className="js-price-rangeSlider">
      <div className="text-14 fw-500"></div>

      <div className="d-flex justify-between mb-10">
        <div className="text-15 text-dark-1">
          <span className="js-lower mx-1">{formatCurrency(price.value.min)}</span>-
          <span className="js-upper mx-1">{formatCurrency(price.value.max)}</span>
        </div>
      </div>

      <div className="px-5">
        <InputRange
          formatLabel={(value, type) => {
            // if (type === 'value') {
            //   return formatCurrency(value);
            // }
            return '';
          }}
          minValue={min}
          maxValue={max}
          value={price.value}
          onChange={value => handleOnChange(value)}
          onChangeComplete={(v: any) => onChange(v.min, v.max)}
        />
      </div>
    </div>
  );
};

export default PriceSliderFilter;
